import styles from './topFundsSection.scss';

import AMCFundTableNew from '../../amc/amcFundTableNew';
import { Router } from '../../../configs/routes';
import { Component } from 'react';
import FundAvatarNew from '../../common/fundAvatarNew';
import { TOP_MUTUALFUNDS_STATIC } from '../../../constants/homeConstantsNew';

interface Props {
  SECTION_TOP_FUNDS: Record<string, any>;
  searchFund: (
    fundType: string,
    categoryType?: string,
    index?: number
  ) => Promise<void>;

  topFunds: Record<string, any>[];
}
interface State {
  selectedFundIndex: number;
  comparisonObj: Record<string, boolean>;
  topfundsLimit: number;
}

// export const TopFundsSection = ({SECTION_TOP_FUNDS,topFunds}) =>(<div>{Object.keys(SECTION_TOP_FUNDS).length}{topFunds.length}</div>)
class TopFundsSection extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      selectedFundIndex: 0,
      comparisonObj: {},
      topfundsLimit: 5,
    };
  }

  public onCheckBoxChecked = (ele: any, checked: any) => {
    if (checked) {
      this.setState({
        comparisonObj: {
          ...this.state.comparisonObj,
          [ele.fundMetaData.isinCode]: true,
        },
      });
    } else {
      const obj = { ...this.state.comparisonObj };
      delete obj[ele.fundMetaData.isinCode];
      this.setState({ comparisonObj: { ...obj } });
    }
  };
  public getTableItems() {
    const a = this.props.topFunds.map((ele) => {
      // let {fundName,imageUrl}
      return {
        rowItems: [
          {
            component: (
              <FundAvatarNew
                fundItem={ele}
                width={12}
                columnWidth={screen.width > 768 ? 250 : 220}
                infoWidth={15}
                hideSubTitle={false}
                source="amc"
                className="lil-pl-4 sm:lil-pl-2 lil-h-10"
              />
            ),
          },
          {
            className: 'sm:lil-hidden',
            component: <span className="lil-text-s-14">{ele.nav}</span>,
          },
          {
            className: '',
            component: <span className="lil-text-s-14">{ele.return5yr}%</span>,
          },
          {
            className: 'sm:lil-hidden',
            component: <span className="lil-text-s-14">{ele.risk}</span>,
          },
          {
            className: 'sm:lil-hidden',
            component: <span className="lil-text-s-14">{ele.exitLoad}</span>,
          },
          {
            component: (
              <input
                type="checkbox"
                checked={!!this.state.comparisonObj[ele.fundMetaData.isinCode]}
                onChange={(e) => {
                  if (ele && ele.fundMetaData) {
                    this.onCheckBoxChecked(ele, e.target.checked);
                  }
                }}
              />
            ),
          },
        ],
      };
    });
    return a;
  }

  public getComparisonString = () => {
    return Object.keys(this.state.comparisonObj)
      .map((ele) => ele)
      .join(',');
  };
  public render() {
    const { SECTION_TOP_FUNDS, searchFund } = this.props;
    const { selectedFundIndex, topfundsLimit, comparisonObj } = this.state;
    const comparisonLength = Object.keys(comparisonObj).length;
    const selectedFund = SECTION_TOP_FUNDS.filters[selectedFundIndex].title;
    return (
      <div id="top-funds" className="lil-mt-16">
        <div className="lil-container">
          <h2 className={`lil-py-2 lil-text-s-56 sm:lil-text-s-32`}>
            Top Mutual Funds by Category
          </h2>
          <p>Top Performing Funds across Categories</p>
          <div className="lil-py-6">
            {SECTION_TOP_FUNDS.filters.map((ele, index) => {
              return (
                <button
                  className={`lil-border-grey-350 lil-border-sm lil-btn lil-font-medium lil-text-grey-500 lil-mr-4 lil-rounded-xl lil-px-4 lil-mt-3 lil-py-2 sm:lil-text-s-14 ${
                    index === selectedFundIndex
                      ? 'lil-bg-font-500 lil-text-white'
                      : ''
                  }`}
                  onClick={() => {
                    searchFund(ele.fundType, ele.categoryFilterValue, index);
                    this.setState({ selectedFundIndex: index });
                  }}
                >
                  {ele.title}
                </button>
              );
            })}
          </div>
        </div>

        <div className="lil-container sm:lil-w-full sm:lil-px-0">
          <div className="lil-flex sm:lil-flex-col">
            <div className="lil-w-10/12 sm:lil-w-full">
              {
                <AMCFundTableNew
                  itemtype="http://schema.org/Table"
                  itemprop="about"
                  title={''}
                  headingData={SECTION_TOP_FUNDS.fundsTable.heading}
                  // returnTimeHeading={selectedReturnTime}
                  tableContainerBorder={true}
                  limit={topfundsLimit}
                  rowBottomBorder={true}
                  bodyData={this.getTableItems()}
                >
                  <div className="lil-flex lil-font-medium lil-justify-between lil-px-4 lil-py-4 lil-items-center">
                    <button
                      className="lil-btn-link"
                      onClick={() =>
                        this.setState({
                          topfundsLimit: this.state.topfundsLimit + 3,
                        })
                      }
                    >
                      View More{' '}
                      <img
                        src="https://assets1.cleartax-cdn.com/cleartax/images/1633258130_vector153.png"
                        alt=""
                        height="15"
                        width="15"
                        className="lil-ml-2 lil-mt-2"
                      />
                    </button>
                    {comparisonLength ? (
                      <button
                        className="lil-btn lil-btn-blue"
                        onClick={() =>
                          Router.pushRoute(
                            `/save/compare-funds?isinCodes=${this.getComparisonString()}`
                          )
                        }
                      >
                        Compare({comparisonLength})
                      </button>
                    ) : null}
                  </div>
                </AMCFundTableNew>
              }
            </div>
            <div className="lil-pt-6 lil-ml-16 sm:lil-ml-0 lil-w-4/12 sm:lil-w-full sm:lil-px-6">
              <p
                className={`lil-font-semibold lil-text-font-400 lil-text-s-20 ${styles['alignItemCenter']}`}
              >
                Insights
              </p>

              {selectedFund ? (
                <div>
                  {TOP_MUTUALFUNDS_STATIC[selectedFund].map((ele) => {
                    return (
                      <div className={`lil-flex lil-mt-5`}>
                        <img
                          src="https://assets1.cleartax-cdn.com/cleartax/images/1629886813_ic_tickmark1.png"
                          alt=""
                          className="lil-h-5 lil-mr-3 lil-pt-1"
                        />
                        <p className="lil-font-medium lil-text-font-400 lil-text-base">
                          {ele.title}
                        </p>
                      </div>
                    );
                  })}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TopFundsSection;



// WEBPACK FOOTER //
// ./components/homePageNew/topFundsSection/topFundsSection.tsx